import axios from 'axios';
import _ from 'lodash';
import { GraphQLClient } from 'graphql-request';

import { auth } from '../auth';
import config from '../config';

export const API_URL = config.api || 'http://127.0.0.1:9080';
export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';

export const apiUrl = url => `${API_URL}/${url}`;

const createClient = () => new GraphQLClient(apiUrl('graphql'), {
  headers: {
    Authorization: `Bearer ${auth.token}`,
  },
});

export const parseResponse = (e) => {
  const resp = _.get(e, 'data', {});
  const ret = {
    message: 'OK',
    statusCode: 200,
    success: true,
    data: {},
    ...resp,
  };
  return ret;
};

export const parseError = (e) => {
  let resp = _.get(e, 'response.data', {});
  if (_.isString(resp)) {
    resp = {
      message: resp,
    };
  }
  const error = {
    message: 'An unknown error occured',
    statusCode: 0,
    errors: [],
    success: false,
    ...resp,
  };
  return error;
};

axios.interceptors.response
  .use(
    response => parseResponse(response),
    error => Promise.reject(parseError(error))
  );


export class API {
  constructor(options) {
    const { id = _.uniqueId(), baseUrl } = options;
    this.options = options;
    this.id = id;
    this.baseUrl = baseUrl;
    this.graphql = false;
    if (this.baseUrl.includes('graphql')) {
      this.graphql = true;
    }
  }

  buildUrl(options = {}) {
    const { params = [], query = {}, baseUrl = this.baseUrl } = options;
    let url = options.url || `${baseUrl}`;
    _.each(params, (p) => {
      url += `/${p}`;
    });
    if (!_.isEmpty(query)) {
      url += '?';
      _.each(query, (v, k) => {
        if (!_.isUndefined(v)) {
          url += `${k}=${v}&`;
        }
      });
      url = url.substr(0, url.length - 1);
    }
    return apiUrl(url);
  }

  get(options = {}) {
    const { query = '', data = {} } = options;
    if (this.graphql) {
      return createClient(apiUrl(this.baseUrl)).request(query, data);
    }
    const url = this.buildUrl(options);
    return axios.get(url);
  }

  put(options = {}, data = {}) {
    const url = this.buildUrl(options);
    return axios.put(url, data);
  }

  post(options = {}, data = {}) {
    const url = this.buildUrl(options);
    return axios.post(url, data);
  }

  delete(options = {}) {
    const url = this.buildUrl(options);
    return axios.delete(url);
  }
}

export {
  axios,
};



// WEBPACK FOOTER //
// ./src/lib/api/API.js